module.exports = __webpack_public_path__ + "img/breadcrumb-bg.06c7a3cc.jpg";